import React from 'react';

import { Card, Row, Col } from 'react-bootstrap';

import DHeader from '../pieces/DHeader';
import DText from '../pieces/DText';
import DCode from '../pieces/DCode';

export const NodeSpec = ({ title, dependencies, config, inputs, outputs, description, example }) => {
  

  return (

    <div>

      <Card style={{padding:'10px', paddingBottom:'20px',marginBottom:'10px', border:'None', borderBottom:'1px solid #e0e0e0'}}>

     

      <DHeader className='h3'>{title}</DHeader>

      <DHeader className='h4'>Dependencies</DHeader>

      {dependencies.map((dependency) => (
        <DText  >{dependency}</DText>
      ))}

      <DHeader className='h4'>Config</DHeader>

      {config.map((config) => (
        <DText>{config}</DText>
      ))}

      <Row>
        <Col>
        <DHeader className='h4'>Inputs</DHeader>
        <table>
          <thead> 

          </thead>
          <tbody>
            {inputs.map((input) => (
              <tr>
                <td>{input.name}</td>
                <td>{input.description}</td>
                <td>{input.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </Col>
        <Col>
        <DHeader className='h4'>Outputs</DHeader>
        <table>
          <thead> 

          </thead>
          <tbody>
            {inputs.map((input) => (
              <tr>
                <td>{input.name}</td>
                <td>{input.description}</td>
                <td>{input.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </Col>
      </Row>


      <DHeader className='h4'>Description</DHeader>
      <DText>{description}</DText>


      <DHeader className='h4'>Example</DHeader>

      <DCode>{example}</DCode>

      </Card>

    </div>

  )
  
};

export default NodeSpec;

